module.exports = __webpack_public_path__ + "static/media/arrival-icon.7264d8dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/arrival-icon.svg
// module id = 787
// module chunks = 0